const COMMON_DEFAULT_VALUE = {
  'grossRevenue': null,
  'netProfit': null,
};

// 固定排序的bo
const FIXED_BO_ORDER_MAP = [
  'amplifier',
  'astra',
  'nexus',
  'saturn',
  'solar',
];

export {
  COMMON_DEFAULT_VALUE,
  FIXED_BO_ORDER_MAP,
}
